import backForDocMalta from "@/src/assets/admissionOfficePage/back-for-doc-malta.webp";
import backForDocPoland from "@/src/assets/admissionOfficePage/back-for-doc-poland.webp";
import backForDocUkraine from "@/src/assets/admissionOfficePage/back-for-doc-ukraine.webp";
import backForDocMaltaNoQr from "@/src/assets/admissionOfficePage/back-for-doc-malta-no-qr.png";
import backForDocUkraineNoQr from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-no-qr.png";
import type { AdmissionOfficeCountry } from "@/src/components/AdmissionsOfficePage/admissionOfficeCountry";

const BACKGROUNDS: Record<AdmissionOfficeCountry, string> = {
  malta: backForDocMalta,
  poland: backForDocPoland,
  ukraine: backForDocUkraine,
};

const NO_QR_BACKGROUNDS: Partial<Record<AdmissionOfficeCountry, string>> = {
  malta: backForDocMaltaNoQr,
  ukraine: backForDocUkraineNoQr,
};

export const getAdmissionOfficePreviewBackground = (country: AdmissionOfficeCountry, withQR = true) => {
  if (!withQR) {
    const noQrBackground = NO_QR_BACKGROUNDS[country];
    if (noQrBackground) return noQrBackground;
  }

  return BACKGROUNDS[country];
};
